import React from 'react'
import { useTranslation } from 'react-i18next'

import { Trash16 } from '@makyoapp/makyo-icon/icon'
import { NavItem } from '@makyoapp/makyo-ui'

import { USER_TRASH_ROUTE } from '@/shared/constants'

import { userNavLink } from './shared'

export function UserTrashMenuItem() {
  const { t } = useTranslation()
  return <NavItem text={t('Trash')} icon={<Trash16 />} to={userNavLink(USER_TRASH_ROUTE)} />
}
